<template>
  <toolbar-container>
    <template #toolbar>
      <reports-toolbar />
    </template>

    <!-- overall -->
    <v-row class="pa-3 ma-0">
      <v-col
        cols="12"
        class="pa-0 ma-0 mb-3"
      >
        <ratings-bar-chart
          :title="$t('label.rating_general')"
          :category="overall.category"
          :series="overall.series"
          :avg-series="overall.avgSeries"
        />
      </v-col>
    </v-row>

    <!-- food -->
    <v-row class="pa-3 ma-0">
      <v-col
        cols="12"
        class="pa-0 ma-0 mb-3"
      >
        <ratings-bar-chart
          :title="$t('label.rating_food')"
          :category="food.category"
          :series="food.series"
          :avg-series="food.avgSeries"
        />
      </v-col>
    </v-row>

    <!-- service -->
    <v-row class="pa-3 ma-0">
      <v-col
        cols="12"
        class="pa-0 ma-0 mb-3"
      >
        <ratings-bar-chart
          :title="$t('label.rating_service')"
          :category="service.category"
          :series="service.series"
          :avg-series="service.avgSeries"
        />
      </v-col>
    </v-row>

    <!-- ambience -->
    <v-row class="pa-3 ma-0">
      <v-col
        cols="12"
        class="pa-0 ma-0 mb-3"
      >
        <ratings-bar-chart
          :title="$t('label.rating_ambience')"
          :category="ambience.category"
          :series="ambience.series"
          :avg-series="ambience.avgSeries"
        />
      </v-col>
    </v-row>
  </toolbar-container>
</template>

<script lang="ts">

import Vue from 'vue';

import RatingsBarChart from '@/components/views/reports/RatingsBarChart.vue';
import ReportsToolbar from '@/components/views/reports/ReportsToolbar.vue';
import { loadStoreModule, unloadStoreModule } from '@/services/module-loader';
import ReportsStore from '@/store/reports-store';
import { ReportsType } from '@/services/reports';
import { RatingChartData, ratingChartData } from '@/services/reports-feedback-utils';

export default Vue.extend({
  name: 'ReportFeedback',
  components: {
    RatingsBarChart,
    ReportsToolbar,
  },
  data() {
    return {};
  },
  computed: {
    overall(): RatingChartData { return ratingChartData('overall'); },
    food(): RatingChartData { return ratingChartData('food'); },
    service(): RatingChartData { return ratingChartData('service'); },
    ambience(): RatingChartData { return ratingChartData('ambience'); },

  },
  created() {
    loadStoreModule(this, 'reports', ReportsStore, async () => {
      this.$tstore.dispatch('updateReports', { reportsType: ReportsType.Feedback });
    });
  },
  beforeDestroy() {
    unloadStoreModule(this, 'reports', async () => { this.$tstore.dispatch('resetReports'); });
  },
  methods: {},
});

</script>
